import * as React from 'react';
import { Spinner } from 'components';
import classNames from 'lib/classNames';

const Callback = ({ loginUrl, errorMessage }) => {
	return errorMessage ? (
		<Banner
			errorMessage={errorMessage}
			title="Authentication Error"
			status="critical"
			action={{ content: 'Try again', url: loginUrl }}
		/>
	) : (
		<Spinner text="Redirecting, please wait..." />
	);
};

const Banner = ({ title, errorMessage, action }) => {
	return (
		<div className={classNames('text-gray-700')}>
			<h3 className={classNames('font-bold text-xl mb-2')}>{title}</h3>

			<p className={classNames('text-gray-700 text-base mb-5')}>{errorMessage}</p>

			<a
				className={classNames('bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded')}
				href={action.url}
			>
				{action.content}
			</a>
		</div>
	);
};

export default Callback;
